import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Badge,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import AgentService from "../../../services/KangarooServices/AgentService";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import {
  formatDate,
  formatDateTime,
} from "../../../Components/Common/FormatDate";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import Select from "react-select";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";

const AgentAvailability = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editingTag, setEditingTag] = useState(null);
  const [agentData, setAgentData] = useState([]);
  const [agentId, setAgentId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);
  const navigate = useNavigate();

  // Fetch all tags
  const fetchData = async () => {
    try {
      setLoading(true);
      const result = await AgentService.getAvailable();
      setData(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggleModal = (tag = null) => {
    setEditingTag(tag);
    setModalOpen(!modalOpen);
  };

  const fetchGroup = async () => {
    try {
      setLoading(true);
      const response = await AgentService.getList();
      setAgentData(response || []);
    } catch (error) {
      console.error("Error fetching media groups:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroup();
  }, []);

  // const handleTagClick={
  //   navigate(`/tag/detail/${id}`);
  // }
  const dateToTicks = (date) => {
    if (!date) return 0;

    // Get seconds since midnight
    const seconds =
      date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();

    return seconds * 10_000_000;
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      agentId: editingTag?.agentId || "",
      date: editingTag?.date ? new Date(editingTag.date) : null,
      availableFrom: editingTag?.availableFrom || "", // string "HH:mm"
      availableTo: editingTag?.availableTo || "", // string "HH:mm"
      isUnavailable: editingTag?.isUnavailable ?? false,
    },

    onSubmit: async (values, { resetForm }) => {
      const payload = {
        agentId: values.agentId,
        date: values.date?.toISOString(),
        availableFrom: values.availableFrom, // "HH:mm"
        availableTo: values.availableTo, // "HH:mm"
        isUnavailable: values.isUnavailable,
      };

      try {
        if (editingTag?.id) {
          await AgentService.updateAvailable(editingTag.id, payload);
          toast.success("Agent avaliability updated succesfull..");
        } else {
          await AgentService.createAvailable(payload);
          toast.success("Agent avaliability created succesfull..");
        }
        fetchData();
        toggleModal(null);
        resetForm();
      } catch (error) {
        console.error(error);
      }
    },
  });

  const customStyles = {
    headCells: { style: { fontSize: "0.9rem", fontWeight: 600 } },
    rows: { style: { fontSize: "0.9rem" } },
  };

  const filteredData = data.filter((item) =>
    (item.name || "").toLowerCase().includes(filterText.toLowerCase())
  );

  const columns = [
    {
      name: "S. No",
      cell: (row, index) => <div>{index + 1}</div>,
      width: "90px",
      center: true,
    },
    {
      name: "Name",
      cell: (row) => (
        <span
          style={{
            cursor: "pointer",
            color: "#0d6efd",
            textDecoration: "none",
          }}
          onClick={() => navigate(`/tag/detail/${row.id}`)}
        >
          {row.agentName}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Date",
      cell: (row) => <span>{formatDate(row.date)}</span>,

      sortable: true,
    },
    {
      name: "Available From",
      selector: (row) => row.email || "not found",
      cell: (row) => <span>{row.availableFrom}</span>,

      sortable: true,
    },
    {
      name: "Available To",
      selector: (row) => row.email || "not found",
      cell: (row) => <span>{row?.availableTo}</span>,

      sortable: true,
    },
    {
      name: "Available?",
      selector: (row) => row.isUnavailable,
      sortable: true,
      cell: (row) => (
        <Badge color={row.isUnavailable ? "danger" : "success"}>
          {row.isUnavailable ? "No" : "Yes"}
        </Badge>
      ),
    },
    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <div>
          <Button
            size="sm"
            color="warning"
            className="btn-soft-warning me-2 p-1"
            onClick={() => toggleModal(row)}
          >
            <i className="ri-pencil-line"></i>
          </Button>
          <Button
            size="sm"
            color="danger"
            className="btn-soft-danger p-1"
            onClick={() => handleDeleteClick(row?.id)}
          >
            <i className="ri-delete-bin-5-line"></i>
          </Button>
        </div>
      ),
    },
  ];
  const agentOptions = agentData.map((type) => ({
    value: type.id,
    label: type.name,
  }));
  // delete
  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await AgentService.deleteAvailable(selectedDeleteItem);
        fetchData();
        toast.success("Agent deleted successfully");
      } catch (error) {
        toast.error("Delete failed");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Agent Availability" pageTitle="Agent management" />

        <Row className="g-4 mb-4 d-flex justify-content-between">
          <Col className="col-sm-auto">
            <Button color="success" onClick={() => toggleModal(null)}>
              <i className="ri-add-line align-bottom me-1"></i> Add Agent
              Availability
            </Button>
          </Col>
          <Col md={6} sm="4">
            <Input
              type="text"
              placeholder="Search by agent name"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
          </Col>
        </Row>

        {/* Desktop Table */}
        <Card className="d-none d-lg-block">
          <CardBody>
            <CustomDataTable
              columns={columns}
              data={filteredData}
              customStyles={customStyles}
              pagination
              striped
              responsive
              fixedHeader
              progressPending={loading}
            />
          </CardBody>
        </Card>

        {/* Modal for Add/Edit */}
        <Modal isOpen={modalOpen} toggle={() => toggleModal(null)}>
          <ModalHeader toggle={() => toggleModal(null)}>
            {editingTag ? "Update Tag" : "Add Tag"}
          </ModalHeader>
          <ModalBody>
            <form onSubmit={formik.handleSubmit}>
              <FormGroup>
                <Label>Agent</Label>
                <Select
                  name="agentId"
                  options={agentOptions}
                  value={agentOptions.find(
                    (opt) => opt.value === formik.values.agentId
                  )}
                  onChange={(selected) =>
                    formik.setFieldValue(
                      "agentId",
                      selected ? selected.value : ""
                    )
                  }
                  placeholder="Select agent"
                  isClearable
                />
              </FormGroup>

              <FormGroup>
                <Label>Select Date</Label>
                <Flatpickr
                  options={{
                    dateFormat: "Y-m-d",
                    disableMobile: true,
                  }}
                  value={formik.values.date}
                  onChange={(date) => formik.setFieldValue("date", date[0])}
                  className="form-control"
                  placeholder="Select date"
                />
              </FormGroup>

              <FormGroup>
                <Label>Available From</Label>
                <Flatpickr
                  options={{
                    enableTime: true,
                    noCalendar: true,
                    time_24hr: true,
                    dateFormat: "H:i",
                    minuteIncrement: 15,
                    disableMobile: true,
                  }}
                  value={
                    formik.values.availableFrom
                      ? formik.values.availableFrom
                      : ""
                  }
                  onChange={(date) => {
                    if (date[0]) {
                      const hours = date[0]
                        .getHours()
                        .toString()
                        .padStart(2, "0");
                      const minutes = date[0]
                        .getMinutes()
                        .toString()
                        .padStart(2, "0");
                      formik.setFieldValue(
                        "availableFrom",
                        `${hours}:${minutes}`
                      );
                    } else {
                      formik.setFieldValue("availableFrom", "");
                    }
                  }}
                  className="form-control"
                  placeholder="Select start time"
                />
              </FormGroup>

              <FormGroup>
                <Label>Available To</Label>
                <Flatpickr
                  options={{
                    enableTime: true,
                    noCalendar: true,
                    time_24hr: true,
                    dateFormat: "H:i",
                    minuteIncrement: 15,
                    disableMobile: true,
                  }}
                  value={
                    formik.values.availableTo ? formik.values.availableTo : ""
                  }
                  onChange={(date) => {
                    if (date[0]) {
                      const hours = date[0]
                        .getHours()
                        .toString()
                        .padStart(2, "0");
                      const minutes = date[0]
                        .getMinutes()
                        .toString()
                        .padStart(2, "0");
                      formik.setFieldValue(
                        "availableTo",
                        `${hours}:${minutes}`
                      );
                    } else {
                      formik.setFieldValue("availableTo", "");
                    }
                  }}
                  className="form-control"
                  placeholder="Select end time"
                />
              </FormGroup>
              <FormGroup className="d-flex justify-content-between">
                <Label>Is Unavailable?</Label>

                <Input
                  type="checkbox"
                  checked={formik.values.isUnavailable}
                  onChange={(e) =>
                    formik.setFieldValue("isUnavailable", e.target.checked)
                  }
                />
              </FormGroup>
              <ModalFooter>
                <Button color="primary" type="submit">
                  {editingTag ? "Update" : "Add"}
                </Button>
                <Button color="secondary" onClick={() => toggleModal(null)}>
                  Cancel
                </Button>
              </ModalFooter>
            </form>
          </ModalBody>
        </Modal>
      </div>
      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </Container>
  );
};

export default AgentAvailability;
